import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import map from 'lodash/map';

import { getWeeks, startCalculation, checkRunning } from '../../../actions/app/mpt/weeks';
import { getClubs } from '../../../actions/app/mpt/clubs';
import Loader from '../../../components/Loader';
import CardResult from './Card';

import './results.css'

class MptResults extends React.Component {
    constructor(props) {
        super();
        this.state ={
            jobRunning: 'loading',
        };
    }
    componentWillMount() {
        const { dispatch, clubs } = this.props;
        dispatch(getWeeks());
        dispatch(checkRunning());
        this.interval = setInterval(() => dispatch(checkRunning()), 20000);
        if (!clubs.list) dispatch(getClubs());
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.weeks.info.jobRunning !== 'loading') {
            this.setState({
                jobRunning: nextProps.weeks.info.jobRunning
            });
        }
    }

    componentWillUnmount(){
        clearInterval(this.interval);
    }

    calculation() {
        const { dispatch } = this.props;
        this.setState({ jobRunning: true });
        dispatch(startCalculation())
    }

    render() {
        const { entities, clubs } = this.props;
        const { jobRunning } = this.state;
        return (
            <div id="MptResults">
                <header className="content-header">
                    <h1>
                        Dashboard
                        <small>Clubs</small>
                    </h1>
                    <ol className="breadcrumb">
                        {/*<li><i className="fa fa-trophy"/> MPP</li>*/}
                        <li className="text-bold"><Link to="/mpt">Dashboard</Link></li>
                    </ol>
                </header>
                <section className="content">
                    <div className="row">
                        <div id="players-list-widget" className="row">
                            <div className="col-md-12">
                                <div className="box box-default">
                                    <div className="box-header with-border">
                                        <div className="text-center buttonCalcul">
                                            {
                                                jobRunning !== 'loading' &&
                                                <button
                                                    onClick={() => this.calculation()}
                                                    className="btn-danger"
                                                    disabled={jobRunning}
                                                >
                                                    {jobRunning ? 'LOADING...' : 'LAUNCH CALCULATION'}
                                                </button>
                                            }
                                        </div>
                                        {
                                            entities.cards && clubs.list ? (
                                                <table className="table table-responsive table-striped">
                                                    <thead>
                                                    <tr>
                                                        <th>Last name</th>
                                                        <th>Club</th>
                                                        <th>Status</th>
                                                        <th>Destinations</th>
                                                        <th>Price</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        map(entities.cards, card => (
                                                                <CardResult key={card.id} clubsList={clubs.list} card={card}/>
                                                            )
                                                        )
                                                    }
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <Loader />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(
    state => ({
        entities: state.entities,
        clubs: state.app.mpt.clubs,
        weeks: state.app.mpt.weeks,
    }),
    dispatch => ({ dispatch }),
)(MptResults);



// WEBPACK FOOTER //
// ./src/pages/MPT/Results/index.js